export default __webpack_public_path__ + "static/media/gram.9456e51a.png";